import { Button } from "@devhop/ui";
import { PlusIcon } from "lucide-react";

type CustomerGroupsToolbarProps = {
  onCreate: () => void;
  canCreate: boolean | null | undefined;
};

export function CustomerGroupsToolbar({
  onCreate,
  canCreate,
}: CustomerGroupsToolbarProps) {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-4">
      <div>
        <h2 className="font-bold text-xl">ກຸ່ມລູກຄ້າ</h2>
        <p className="text-muted-foreground text-sm">
          ຈັດກຸ່ມລູກຄ້າເພື່ອການຕະຫຼາດ ແລະ ໂປຮໂມຊັ່ນ
        </p>
      </div>
      {canCreate && (
        <Button onClick={onCreate} size="sm">
          <PlusIcon className="h-4 w-4" />
          ສ້າງກຸ່ມ
        </Button>
      )}
    </div>
  );
}
